<template>
  <div class="selector">
    <div class="results-overview">
      <div class="result-no first">
        {{ labels.selMatchingProducts }}: {{ resultCount }} {{ labels.of }}
        {{ totalCount }}
      </div>
      <FlatButton
        label="Show results"
        @click="showResults()"
        blue
        :disabled="resultCount === 0"
      />
    </div>

    <div class="checkbox-container">
      <CheckboxGroup v-for="f in filters" :key="f.filter" :label="f.name">
        <Checkbox
          v-for="c in f.values"
          :key="c"
          :label="c"
          :value="c"
          @change="toggleOption"
        ></Checkbox>
      </CheckboxGroup>
    </div>
  </div>
</template>

<script>
import { CheckboxGroup, Checkbox, FlatButton } from "clariant-vue-forms";
import { DataLayer, Labels, Utils } from "../services";

export default {
  name: "Selector",
  props: ["resultCount", "totalCount"],
  data() {
    return {
      labels: Labels,
      filters: [],
      selectedOptions: [],
    };
  },
  mounted() {
    let loader = Utils.showLoader(".selector");
    DataLayer.getFilters()
      .then((results) => {
        this.constructFilters(results.data);
      })
      .catch((err) => {
        Utils.showStatusMessage(
          `Could not load filters. ${err.message}.`,
          "red"
        );
      })
      .finally(() => {
        Utils.removeLoader(loader);
      });
  },
  methods: {
    constructFilters(data) {
      this.filters = [];
      if (!data) return;
      data.map((f) => {
        let flt = { name: f.Filter, values: [] };
        for (let i = 1; i <= 20; i++) {
          let key = `Value ${i}`;
          if (f.hasOwnProperty(key) && !!f[key]) {
            flt.values.push(f[key]);
          }
        }
        this.filters.push(flt);
      });
    },
    isChecked(id) {
      return this.selectedOptions.indexOf(id) !== -1;
    },
    toggleOption(val) {
      let value = val.sender.label;
      let pos = this.selectedOptions.indexOf(value);
      if (pos == -1) {
        this.selectedOptions.push(value);
      } else {
        this.selectedOptions.splice(pos, 1);
      }
      this.$emit("change", {
        options: this.selectedOptions,
      });
    },
    showResults() {
      DataLayer.recordFilters(this.selectedOptions, this.resultCount);
      if (this.resultCount == 0) return; //we don't switch view if we have no results, but we do record the fact that the user pressed the button.
      this.$emit("click");
    },
  },
  components: {
    Checkbox,
    CheckboxGroup,
    FlatButton,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.checkbox-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.checkbox-container > .cla-checkbox-group {
  width: 40%;
  min-width: 200px;
}

.results-overview {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 2px -2px #bbb;
  outline: none;
  margin-bottom: 30px;
}
.results-overview > div {
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  font-weight: 700;
  font-size: 18px;
  color: black;
}

.result-no.first {
  margin-bottom: 10px;
}

@media all and (max-width: 480px) {
  .checkbox-container > .cla-checkbox-group {
    width: 100%;
    min-width: auto;
  }

  .results-overview {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
